import { render, staticRenderFns } from "./Descript.vue?vue&type=template&id=0272ab38&scoped=true"
import script from "./Descript.vue?vue&type=script&lang=js"
export * from "./Descript.vue?vue&type=script&lang=js"
import style0 from "./Descript.vue?vue&type=style&index=0&id=0272ab38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272ab38",
  null
  
)

export default component.exports